<template>
  <div class="error-container d-flex flex-column">
    <simple-header />
    <div class="error-content">
      <div class="row m-0">
        <div class="col-lg-4 image-col">
          <transition name="bounce" enter-active-class="bounceInLeft">
            <img
              v-if="showWithDelay"
              src="../assets/images/401.png"
              alt="error"
            />
          </transition>
        </div>
        <transition name="bounce" enter-active-class="bounceInRight">
          <div v-if="showWithDelay" class="col-lg-8 text-col">
            <h1>Oops... There was a login error.</h1>
            <p>There is trouble in verifying your identity. Please clear your browser cache and retry. If you need to change your password, please visit <a :href="landingPage" class="error-anchor"><strong>landing.autodesk.com</strong></a> and click on Password Management icon. If problem persists, please contact Service Desk.</p>
            <a class="error-btn" @click="navigateToLanding()" role="link"
              >GO TO LANDING PAGE</a
            >
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
  require("vue2-animate/dist/vue2-animate.min.css");
  import CONSTANTS from "@/constants";
import SimpleHeader from "../components/SimpleHeader";
export default {
  name: "error",
  data() {
    return {
      showWithDelay: false,
      landingPage:CONSTANTS.LANDING_PAGE_URL
    };
  },
  components: {
    SimpleHeader
  },
  computed: {
    message() {
      if(this.$route.query.error == 'access_denied')
        return "Access denied";
      return "";
    }
  },
  mounted() {
    setTimeout(() => {
      this.showWithDelay = true;
    }, 500);
  },
  methods:{
    navigateToLanding(){
      location.href=CONSTANTS.LANDING_PAGE_URL;
    }
  }
};
</script>
<style scoped>
.error-container {
  position: absolute;
}
.error-content {
  width: 100%;
  /* Fix for IE */
  max-width: 800px;
  display: block;
  margin: auto;
  padding-bottom: 10%;
}
.error-btn {
  color: white;
  font-weight: bold;
  padding: 15px;
  border: 1px solid white;
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 3px;
  position: relative;
  display: inline-block;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 6px;
  margin: 6px 8px;
  line-height: 36px;
  min-height: 36px;
  background: 0 0;
  white-space: nowrap;
  min-width: 88px;
  text-align: center;
  text-transform: uppercase;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  overflow: hidden;
}
.error-anchor{
  color:#fff;
}
.error-anchor:hover{
  text-decoration: underline !important;
}
.error-btn:hover {
  opacity: 0.9;
}
  .error-btn{
    margin:6px 0 !important;
  }
</style>
